import { socketConnected, startListening } from '@bonanza-social/toolkit/state';
import { MessageReceivedData } from './notifications.types';
import { BottomSheet } from '@bonanza-social/navigation';

startListening({
  actionCreator: socketConnected,
  effect: (action) => {
    const socketConnection = action.payload;
    socketConnection.on('MessageReceived', (data: MessageReceivedData) => {
      if (!data) {
        return null;
      }

      BottomSheet.open({
        scrollable: true,
        namespace: 'notifications',
        type: 'Notification',
        title: data.title,
        singleton: false,
        data: {
          imageUrl: data.imageUrl,
          message: data.message,
          actionType: data.actionType,
          promotionId: data.actionConfiguration?.promotionId,
          gameId: data.actionConfiguration?.gameId,
        },
      });
    });
  },
});
